import EnumObject from '@/domain/enum-object.entity';
import { BillingStatus } from './billing-status.enum';

export default class BillingSummary {
  amount: number;

  value: string;

  status?: string;

  constructor(obj: any = {}, status?: string) {
    this.amount = obj.amount || 0;
    this.value = obj.value || '';
    this.status = status;
  }

  public static of(obj: any = {}, status?: string): BillingSummary {
    return new BillingSummary(obj || {}, status);
  }
}
